import React, {Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import OidcConfigForm from "../OidcConfigForm/OidcConfigForm";
import {createOidcConfig} from '../../../actions/actionOidc';

class CreateOidcConfig extends Component {
    constructor (props){
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className="mt-4">
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create OpenID Config</strong>
                                </CardHeader>
                                <OidcConfigForm
                                    createOidcConfig={this.props.createOidcConfig}/>
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}


export default connect(state =>
        ({
            oidc_configs: state.oidc.oidc_configs || [],
        }),
dispatch =>
    ({
        createOidcConfig: (data) => dispatch(createOidcConfig(data))
    }))(CreateOidcConfig);

